module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH#_idTextAnchor001"
    }
  }, [_c('span', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH1#_idTextAnchor002"
    }
  }, [_vm._v("THE KITCHEN PHARMACY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH2#_idTextAnchor003"
    }
  }, [_vm._v("Making Your Own Herbal Remedies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageviii",
      "title": "viii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH3#_idTextAnchor004"
    }
  }, [_vm._v("Internal Remedies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH4#_idTextAnchor006"
    }
  }, [_c('span', [_vm._v("External Remedies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH5#_idTextAnchor009"
    }
  }, [_c('span', [_vm._v("Cosmetic Uses of")]), _vm._v(" "), _c('span', [_vm._v(" Herbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH6#_idTextAnchor010"
    }
  }, [_c('span', [_vm._v("Your Magical Works")]), _vm._v(" "), _c('span', [_vm._v("h")]), _vm._v(" "), _c('span', [_vm._v("op")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH7#_idTextAnchor012"
    }
  }, [_vm._v("A-Z HERBAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH8#_idTextAnchor013"
    }
  }, [_c('span', [_vm._v("Basil")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH9#_idTextAnchor014"
    }
  }, [_c('span', [_vm._v("Black Pepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH10#_idTextAnchor015"
    }
  }, [_c('span', [_vm._v("Caraway")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH11#_idTextAnchor016"
    }
  }, [_c('span', [_vm._v("Cardamom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH12#_idTextAnchor017"
    }
  }, [_c('span', [_vm._v("Chilli/Cayenne")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH13#_idTextAnchor018"
    }
  }, [_c('span', [_vm._v("Cinnamon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagex",
      "title": "x"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH14#_idTextAnchor021"
    }
  }, [_c('span', [_vm._v("Clove")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH15#_idTextAnchor022"
    }
  }, [_c('span', [_vm._v("Coriander")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH16#_idTextAnchor023"
    }
  }, [_c('span', [_vm._v("Cumin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH17#_idTextAnchor024"
    }
  }, [_c('span', [_vm._v("Dill")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH18#_idTextAnchor025"
    }
  }, [_c('span', [_vm._v("Fennel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH19#_idTextAnchor026"
    }
  }, [_c('span', [_vm._v("Fenugreek")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH20#_idTextAnchor027"
    }
  }, [_c('span', [_vm._v("Garlic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH21#_idTextAnchor028"
    }
  }, [_c('span', [_vm._v("Ginger")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH22#_idTextAnchor029"
    }
  }, [_c('span', [_vm._v("Lemon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexi",
      "title": "xi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH23#_idTextAnchor030"
    }
  }, [_c('span', [_vm._v("Mints")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH24#_idTextAnchor031"
    }
  }, [_c('span', [_vm._v("Oats")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH25#_idTextAnchor032"
    }
  }, [_c('span', [_vm._v("Oregano")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH26#_idTextAnchor033"
    }
  }, [_c('span', [_vm._v("Parsley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH27#_idTextAnchor034"
    }
  }, [_c('span', [_vm._v("Rosemary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH28#_idTextAnchor035"
    }
  }, [_c('span', [_vm._v("Sage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH29#_idTextAnchor036"
    }
  }, [_c('span', [_vm._v("Thyme")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch-"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH30#_idTextAnchor037"
    }
  }, [_c('span', [_vm._v("Turmeric")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexii",
      "title": "xii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH31#_idTextAnchor038"
    }
  }, [_c('span', [_vm._v("OTHER KITCHEN HERBS IN BRIEF")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-cn"
  }, [_c('span', [_vm._v("appendix 1: ")]), _c('a', {
    attrs: {
      "href": "#/HKWH32#_idTextAnchor040"
    }
  }, [_c('span', [_vm._v("Kitchen Herb Magical Correspondences")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-cn"
  }, [_c('span', [_vm._v("appendix 2: ")]), _c('a', {
    attrs: {
      "href": "#/HKWH33#_idTextAnchor042"
    }
  }, [_c('span', [_vm._v("Colour Correspondences")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-cn"
  }, [_c('span', [_vm._v("appendix 3: ")]), _c('a', {
    attrs: {
      "href": "#/HKWH34#_idTextAnchor043"
    }
  }, [_c('span', [_vm._v("Herbs for Common Ailments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-cn"
  }, [_c('span', [_vm._v("appendix 4: ")]), _c('a', {
    attrs: {
      "href": "#/HKWH35#_idTextAnchor044"
    }
  }, [_c('span', [_vm._v("Glossary of Herbal Terminology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-cn"
  }, [_c('span', [_vm._v("appendix 5: ")]), _c('a', {
    attrs: {
      "href": "#/HKWH36#_idTextAnchor045"
    }
  }, [_c('span', [_vm._v("Cosmetic Uses of Herbs in This Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-cn"
  }, [_c('span', [_vm._v("appendix 6: ")]), _c('a', {
    attrs: {
      "href": "#/HKWH37#_idTextAnchor046"
    }
  }, [_c('span', [_vm._v("Weights and Measures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-cn"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH37#_idTextAnchor047"
    }
  }, [_c('span', [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-cn"
  }, [_c('a', {
    attrs: {
      "href": "#/HKWH37#_idTextAnchor048"
    }
  }, [_c('span', [_vm._v("Recipe Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f3b010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0